app.readspeak = {
    init: function () {

        $('#readspeaker-container').hide();

        $('#toggleReadSpeaker').click(function(e) {

            e.preventDefault();

            if ($('#toggleReadSpeaker').hasClass('rs_visible')){

                $('#toggleReadSpeaker').removeClass('rs_visible');
                $('#readspeaker-container').hide();

                var player = rspkr.ui.getActivePlayer(); player.close();

            } else {

                $('#toggleReadSpeaker').addClass('rs_visible');

                $('#readspeaker-container').show();
                window.readpage($rs.get("#readspeaker-container div > a"));
            }
        });
    }
};